"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = exports.PortfolioType = exports.EducationLevel = void 0;
var Pronouns;
(function (Pronouns) {
    Pronouns["SHE_HER"] = "SHE_HER";
    Pronouns["HE_HIM"] = "HE_HIM";
    Pronouns["THEY_THEM"] = "THEY_THEM";
    Pronouns["OTHERS"] = "OTHERS";
})(Pronouns || (Pronouns = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["BR_CPF"] = "BR_CPF";
    IdentityType["BR_NATIONAL_MIGRATION_REGISTER_CARD"] = "BR_NATIONAL_MIGRATION_REGISTER_CARD";
    IdentityType["BR_PROVISIONAL_REFUGEE_PROTOCOL"] = "BR_PROVISIONAL_REFUGEE_PROTOCOL";
    IdentityType["BR_PASSPORT"] = "BR_PASSPORT";
})(IdentityType || (IdentityType = {}));
var GenderIdentity;
(function (GenderIdentity) {
    GenderIdentity["CIS_MALE"] = "CIS_MALE";
    GenderIdentity["CIS_FEMALE"] = "CIS_FEMALE";
    GenderIdentity["TRANSGENDER_FEMALE"] = "TRANSGENDER_FEMALE";
    GenderIdentity["TRANSGENDER_MALE"] = "TRANSGENDER_MALE";
    GenderIdentity["NON_BINARY"] = "NON_BINARY";
    GenderIdentity["AGENDER"] = "AGENDER";
    GenderIdentity["TRANSVESTITE"] = "TRANSVESTITE";
    GenderIdentity["OTHERS"] = "OTHERS";
})(GenderIdentity || (GenderIdentity = {}));
var Race;
(function (Race) {
    Race["WHITE"] = "WHITE";
    Race["BROWN"] = "BROWN";
    Race["BLACK"] = "BLACK";
    Race["YELLOW"] = "YELLOW";
    Race["INDIGENOUS"] = "INDIGENOUS";
    Race["OTHERS"] = "OTHERS";
})(Race || (Race = {}));
var SocialMediaType;
(function (SocialMediaType) {
    SocialMediaType["LINKEDIN"] = "LINKEDIN";
    SocialMediaType["FACEBOOK"] = "FACEBOOK";
    SocialMediaType["INSTAGRAM"] = "INSTAGRAM";
    SocialMediaType["TWITTER"] = "TWITTER";
    SocialMediaType["TIKTOK"] = "TIKTOK";
    SocialMediaType["GITHUB"] = "GITHUB";
})(SocialMediaType || (SocialMediaType = {}));
var Roles;
(function (Roles) {
    Roles["ADMIN"] = "ADMIN";
    Roles["ADMIN_CLASS"] = "ADMIN_CLASS";
    Roles["ADMIN_CLASS_VACANCY"] = "ADMIN_CLASS_VACANCY";
    Roles["ADMIN_CLASS_VACANCY_BOOTCAMP"] = "ADMIN_CLASS_VACANCY_BOOTCAMP";
    Roles["ADMIN_CLASS_VACANCY_WORKSHOP"] = "ADMIN_CLASS_VACANCY_WORKSHOP";
    Roles["ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA"] = "ADMIN_CLASS_VACANCY_VOLUNTEER_MEDIA";
    Roles["ADMIN_CORPORATE"] = "ADMIN_CORPORATE";
    Roles["ADMIN_CORPORATE_PLACEMENT_VACANCY"] = "ADMIN_CORPORATE_PLACEMENT_VACANCY";
    Roles["STUDENT"] = "STUDENT";
    Roles["CORPORATE"] = "CORPORATE";
    Roles["CANDIDATE"] = "CANDIDATE";
})(Roles || (Roles = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["BLOCKED"] = "BLOCKED";
    Status["DISABLED"] = "DISABLED";
})(Status || (Status = {}));
var BootcampsStatus;
(function (BootcampsStatus) {
    BootcampsStatus["IN_PROCESS"] = "IN_PROCESS";
    BootcampsStatus["FINISHED"] = "FINISHED";
    BootcampsStatus["GIVE_UP"] = "GIVE_UP";
    BootcampsStatus["STOPPED"] = "STOPPED";
    BootcampsStatus["CHANGED"] = "CHANGED";
    BootcampsStatus["DISAPPROVED"] = "DISAPPROVED";
    BootcampsStatus["REPLACED"] = "REPLACED";
})(BootcampsStatus || (BootcampsStatus = {}));
var ScholarshipType;
(function (ScholarshipType) {
    ScholarshipType["INTERNET"] = "INTERNET";
    ScholarshipType["COMPUTER"] = "COMPUTER";
    ScholarshipType["STAY"] = "STAY";
    ScholarshipType["OTHERS"] = "OTHERS";
})(ScholarshipType || (ScholarshipType = {}));
var OpenForProposals;
(function (OpenForProposals) {
    OpenForProposals["NO"] = "NO";
    OpenForProposals["YES_LISTED"] = "YES_LISTED";
    OpenForProposals["YES_NOT_LISTED"] = "YES_NOT_LISTED";
})(OpenForProposals || (OpenForProposals = {}));
var EducationLevel;
(function (EducationLevel) {
    EducationLevel["BASIC"] = "BASIC";
    EducationLevel["FUNDAMENTAL"] = "FUNDAMENTAL";
    EducationLevel["MEDIUM"] = "MEDIUM";
    EducationLevel["MEDIUM_TECHNICAL"] = "MEDIUM_TECHNICAL";
    EducationLevel["UNDERGRADUATE_TECHNICAL"] = "UNDERGRADUATE_TECHNICAL";
    EducationLevel["BACHELOR"] = "BACHELOR";
    EducationLevel["LICENSING"] = "LICENSING";
    EducationLevel["EXTENSION"] = "EXTENSION";
    EducationLevel["MBA"] = "MBA";
    EducationLevel["POST_GRADUATE"] = "POST_GRADUATE";
    EducationLevel["MASTERS"] = "MASTERS";
    EducationLevel["DOCTORATE"] = "DOCTORATE";
    EducationLevel["POST_DOCTORATE"] = "POST_DOCTORATE";
    EducationLevel["OTHERS"] = "OTHERS";
})(EducationLevel = exports.EducationLevel || (exports.EducationLevel = {}));
var PortfolioType;
(function (PortfolioType) {
    PortfolioType["PROJECT"] = "PROJECT";
    PortfolioType["LINK"] = "LINK";
})(PortfolioType = exports.PortfolioType || (exports.PortfolioType = {}));
var EventType;
(function (EventType) {
    EventType["COMMUNICATION"] = "COMMUNICATION";
    EventType["ACTIVITY"] = "ACTIVITY";
    EventType["HOMEWORK"] = "HOMEWORK";
    EventType["ASSIGMNET"] = "ASSIGMNET";
    EventType["FINAL_PROJECT"] = "FINAL_PROJECT";
})(EventType || (EventType = {}));
exports.enums = {
    pronouns: Pronouns,
    identityType: IdentityType,
    genderIdentity: GenderIdentity,
    socialMediaType: SocialMediaType,
    race: Race,
    status: Status,
    bootcampsStatus: BootcampsStatus,
    roles: Roles,
    openForProposals: OpenForProposals,
    educationLevel: EducationLevel,
    portfolioType: PortfolioType,
    eventType: EventType,
    scholarshipType: ScholarshipType,
};
//# sourceMappingURL=User.js.map